import { ILocalStorageItem, LocalStorageItemKeys } from './LocalStorageManager.types';

/**
 * Represents a local storage item which can be saved in window.localStorage object.
 */
class LocalStorageItem implements ILocalStorageItem {
    public key: LocalStorageItemKeys;
    public value: string;

    constructor(key: LocalStorageItemKeys, value: string) {
        this.key = key;
        this.value = value;
    }
}

export default LocalStorageItem;
